import AccessGroupsTab from "components/accessGroups/AccessGroupsTab";
import Layout from "components/Layout";
import ManagementPageShell from "components/management/ManagementPageShell";

/** Super Admin only (the route checks `access_groups.manage`); no Client View twin. */
export default function AccessGroupsPage() {
  return (
    <Layout title="Access Groups" noScroll>
      <ManagementPageShell title="Access Groups">
        <AccessGroupsTab />
      </ManagementPageShell>
    </Layout>
  );
}
